import {
  contentActions,
  contentGetters,
  contentMutations,
  getDefaultContentState,
} from './modules/project-tree/content.js';
import {
  getDefaultNavigationState,
  navigationActions,
  navigationGetters,
  navigationMutations,
} from './modules/project-tree/navigation.js';

function getDefaultState() {
  return {
    ...getDefaultNavigationState(),
    ...getDefaultContentState(),
  };
}

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  ...navigationMutations,
  ...contentMutations,
};

const actions = {
  ...navigationActions,
  ...contentActions,
};

const getters = {
  ...navigationGetters,
  ...contentGetters,
};
export default {
  namespaced: true,
  state: getDefaultState(),
  mutations,
  actions,
  getters
};
